// Stores state of a flashcard session
//
// Current test deck
// Current word
//
// Actions:
// - start test (from specific IDs, or with number of cards)
// - exit test
// - next word
// - reveal word
// - recall word
import Backbone from "backbone";
import * as _ from "underscore";

const FlashcardSessionModel = Backbone.Model.extend({
  constructor: function (attributes) {
    this.models = attributes.models;
    Backbone.Model.apply(this, _.omit(attributes, "models"));
  },
  reset: function () {
    this.set("currentTestDeck", []);
    this.set("currentDeckSize", 0); // original size of deck at start
    this.set("currentWord", null);
  },
  start: function (readyToTest, numberOfCards, mixedMode) {
    // set 50% of the active cards to passive
    const currentTestDeck = _.shuffle(readyToTest.first(numberOfCards));

    if (mixedMode) {
      _.each(currentTestDeck, (userWord) => {
        userWord.set("passiveOverride", Math.random() < 0.5);
      });
    }

    this.set("currentTestDeck", currentTestDeck);
    this.set("currentDeckSize", this.get("currentTestDeck").length);
  },
  deleteCurrentWord: function () {
    const index = _.pluck(this.get("currentTestDeck"), "id").indexOf(
      this.get("currentWord").id
    );
    if (index !== -1) {
      this.get("currentTestDeck").splice(index, 1);
    }
    this.models.userWords.remove(this.get("currentWord"));
    this.get("currentWord").destroy({ success: function () {} });
  },
  reportRecallEase: async function (ease, repeatUntilPerfect) {
    const currentWord = this.get("currentWord");
    const currentTestDeck = this.get("currentTestDeck");
    currentTestDeck.shift();

    let toWait = await this.models.userWords.reportRecallEase(
      currentWord,
      ease
    );

    if (
      (currentWord.get("passiveOverride") && ease > 3) ||
      (repeatUntilPerfect && ease === 4)
    ) {
      toWait = 10;
    }

    currentWord.set("passiveOverride", false); // only needed for the first exposure to the word

    if (toWait > 0) {
      currentTestDeck.splice(
        Math.max(currentTestDeck.length, toWait),
        0,
        currentWord
      );
    }
  },
  /** @returns {boolean} true if a session is currently in progress */
  inProgress: function () {
    const currentTestDeck = this.get("currentTestDeck");
    return currentTestDeck ? currentTestDeck.length > 0 : false;
  },
});

export default FlashcardSessionModel;
